module.exports = __webpack_public_path__ + "static/media/magic-stick-fill-white.5d3d26fc.svg";